import { Grid, createStyles, makeStyles } from '@material-ui/core'
import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import TextField from '../TextField/TextField'
import { useAddress } from '../../hooks/useAddress'
import { AreaAddress } from '../../redux/reducers/addressReducer'
import { prismicText } from '../Global/CMSText'
import clsx from 'clsx'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      margin: theme.spacing(0, 0, 2),
    },
    form: {},
    formContent: {
      margin: theme.spacing(0, 0, 2),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(0, 2),
      },
    },
    cardTitle: {
      textAlign: 'center',
      marginBottom: theme.spacing(1),
    },
    success: {
      color: theme.palette.success.main,
    },
    changeButton: {
      padding: theme.spacing(1, 3),
      margin: theme.spacing(1, 0),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(1, 2),
      },
    },
  })
)

interface AreaAddressFormProps {
  prefill?: boolean
  addressType: 'billing' | 'shipping'
  className?: string
}

const AreaAddressForm = ({
  prefill = false,
  addressType,
  className,
}: AreaAddressFormProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const prismicAccount = useSelector((state) => state.prismic.account)

  function formatPayloadAddress(inputAddress: AreaAddress) {
    const { street, area, city } = inputAddress
    const isValid = Boolean(street && area && city)

    let payloadAddress
    if (isValid) {
      payloadAddress = {
        street,
        postcode: area,
        city,
        countryCode: 'AE',
      }
    }

    return { payloadAddress, isValid }
  }

  function initAreaAddress(shippingAddress) {
    if (prefill && shippingAddress) {
      return {
        street: shippingAddress.street,
        area: shippingAddress.postcode,
        city: shippingAddress.city,
      }
    }
    return { street: '', area: '', city: '' }
  }

  const { address, saveInputAddress } = useAddress(
    addressType,
    initAreaAddress,
    formatPayloadAddress
  )

  const inputAddress = address.input as AreaAddress

  function onChange(value, key) {
    saveInputAddress({
      ...inputAddress,
      [key]: value,
    })
  }

  const text = (key: string) =>
    prismicText(prismicAccount[key], t(`texts:account:area_address:${key}`))

  return (
    <div className={clsx(classes.root, className)}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <TextField
            label={text('label_city')}
            placeholder={text('placeholder_city')}
            type="text"
            name="address_details"
            value={inputAddress?.city}
            onChange={(value) => onChange(value, 'city')}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={text('label_area')}
            placeholder={text('placeholder_area')}
            type="text"
            name="address_details"
            value={inputAddress?.area}
            onChange={(value) => onChange(value, 'area')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label={text('label_address_details')}
            placeholder={text('placeholder_address_details')}
            type="text"
            name="address_details"
            value={inputAddress?.street}
            onChange={(value) => onChange(value, 'street')}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default AreaAddressForm
